import RoutesEnum from 'enums/routes.enum'
import LoadSessionMiddleware from 'middlewares/LoadSessionMiddleware'
import ForbidSubdomainMiddleware from 'middlewares/ForbidSubdomainMiddleware'

export default [
    {
        path: '/',
        name: RoutesEnum.INDEX.HOME,
        view: 'index/Home',
        middlewares: [LoadSessionMiddleware, ForbidSubdomainMiddleware],
        meta: {
            layout: 'main',
            title: 'Bookeraj - Rezerviši i Pruži Usluge Online',
            description:
                'Naše online mesto vam omogućava da lako rezervišete različite usluge ili ponudite svoje usluge drugima. Pronađite i rezervišite ono što vam treba.',
        },
    },
]
